import { fetchResume } from './resume'
import { Downloader } from './types'

const downloaders: Record<string, Downloader> = {
    resume: fetchResume,
    r: fetchResume,
}

export function getDownloader(type: string): Downloader | undefined {
    return downloaders[type]
}
